/**
 * Authorize.NET AVS and CVV response codes and labels.
 *
 * AVS documentation:
 *   https://support.authorize.net/knowledgebase/Knowledgearticle/?code=KA-05377
 *
 * CVV documentation:
 *   https://support.authorize.net/knowledgebase/Knowledgearticle/?code=KA-05378
 */

export enum AVSCode {
    StreetMatchesZipDoesNot = 'A',
    AddressNotProvidedOrZipNotVerified = 'B',
    AvsProcessingError = 'E',
    NonUsBankNoAvs = 'G',
    NoStreetOrZipMatch = 'N',
    NotApplicable = 'P',
    Retry = 'R',
    AvsNotSupportedByBank = 'S',
    AddressInfoUnavailable = 'U',
    Zip9MatchStreetNoMatch = 'W',
    StreetAndZip9Match = 'X',
    StreetAndZip5Match = 'Y',
    Zip5MatchStreetNoMatch = 'Z',
}

export enum CVVCode {
    Match = 'M',
    NoMatch = 'N',
    NotProcessed = 'P',
    ShouldBeOnCardButBlank = 'S',
    IssuerNotCertifiedOrNoEncryptionKey = 'U',
}

export const AVS_CODE_LABELS: Record<AVSCode, string> = {
    [AVSCode.StreetMatchesZipDoesNot]: 'Street matches, ZIP does not',
    [AVSCode.AddressNotProvidedOrZipNotVerified]:
        'Address not provided for AVS check, or street matched but postal code could not be verified',
    [AVSCode.AvsProcessingError]:
        'AVS error — processing network error, AVS data unavailable',
    [AVSCode.NonUsBankNoAvs]: 'Non-U.S. bank — AVS not supported',
    [AVSCode.NoStreetOrZipMatch]: 'Neither street address nor ZIP matches',
    [AVSCode.NotApplicable]: 'AVS not applicable for this transaction type',
    [AVSCode.Retry]: 'AVS temporarily unavailable — retry',
    [AVSCode.AvsNotSupportedByBank]: 'Card issuing bank does not support AVS',
    [AVSCode.AddressInfoUnavailable]: 'Address information unavailable',
    [AVSCode.Zip9MatchStreetNoMatch]:
        '9-digit ZIP matches, street address does not',
    [AVSCode.StreetAndZip9Match]: 'Street address and 9-digit ZIP match',
    [AVSCode.StreetAndZip5Match]: 'Street address and 5-digit ZIP match',
    [AVSCode.Zip5MatchStreetNoMatch]:
        '5-digit ZIP matches, street address does not',
};

export const CVV_CODE_LABELS: Record<CVVCode, string> = {
    [CVVCode.Match]: 'Match',
    [CVVCode.NoMatch]: 'Does not match',
    [CVVCode.NotProcessed]: 'Not processed',
    [CVVCode.ShouldBeOnCardButBlank]:
        'Should be on card — left blank by customer',
    [CVVCode.IssuerNotCertifiedOrNoEncryptionKey]:
        'Issuer not certified for CVV2 or has not provided encryption key',
};
